import React from 'react';
import styled from 'styled-components';
import { OntarioRow, OntarioColumn, Heading1, Heading2, TextParagraph } from '../theme';
import { spacing, media } from '../theme';
import { AdminMessage } from '../entities/formTemplateDataType';

// Maintenance page styled components
const Wrapper = styled.div`
    margin-top: -120px;
    height: 100vh;
    background-image: url(${process.env.PUBLIC_URL==='/' ?  '' : process.env.PUBLIC_URL}/assets/images/ontario-trillium-bg.svg);
    background-repeat: no-repeat;
    background-position: top -${spacing.spacing5} right -3.5rem;
    background-size: 250px;

    @media ${media.small} {
        background-size: 450px;
        background-position: top -${spacing.spacing4} right ${spacing.spacing4};
    }

    @media ${media.medium} {
        background-size: 600px;
        background-position: top right ${spacing.spacing9};
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: calc(${spacing.spacing9} + ${spacing.spacing2});

    @media ${media.small} {
        margin-top: calc(${spacing.spacing9} + ${spacing.spacing9} + ${spacing.spacing2});
    }
`;

const LogoImage = styled.img`
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    max-width: 200px;
  `;

const MarginBlock = styled.div`
    margin-top: ${spacing.spacing1};

    @media ${media.small} {
        margin-top: ${spacing.spacing6};
    }
`;

export const LeadText = styled.p`
    font-size: 1.25rem;
    line-height: 1.6;

    @media ${media.small} {
        font-size: 1.375rem;
    }
`;

const Maintenance = ({
    adminConfig,
    lang,
    app,
}: {
    adminConfig?: AdminMessage;
    lang: 'en' | 'fr';
    app: string;
}) => {
    return (
        <Wrapper>
            {/* {lang === 'en' && <h1>{`Application ${app} is under maintenace.`}</h1>}
            {lang === 'fr' && <h1>{`Application ${app} is under maintenace.`}</h1>} */}
            
            <OntarioRow>
                <OntarioColumn>
                    <TextContainer>
                        <LogoImage src={`${process.env.PUBLIC_URL==='/' ?  '' : process.env.PUBLIC_URL}/assets/images/ontario-logo--maintenance.png`}/>
                        <div lang="en">
                            <Heading1>We&apos;ll be back soon!</Heading1>
                            <LeadText style={{ marginBottom: '0' }}>
                                <span>This service is currently down for maintenance.</span>
                                <TextParagraph key={`maintaining-message-${Math.random()}`}>
                                    {adminConfig?.messageContent ?? ''}
                                </TextParagraph>
                            </LeadText>
                            <LeadText style={{ marginTop: '0' }}>
                                We apologize for any inconvenience. Thank you for your
                                understanding.
                            </LeadText>
                            <TextParagraph>Please visit us again.</TextParagraph>
                        </div>

                        <MarginBlock lang="fr">
                            <h2>Nous serons de retour bientôt!</h2>
                            <LeadText style={{ marginBottom: '0' }}>
                                    <span>
                                        Ce service est actuellement indisponible pour maintenance.
                                    </span>
                                    <TextParagraph key={`maintaining-message-${Math.random()}`}>
                                        {adminConfig?.messageContentFrench ?? ''}
                                    </TextParagraph>
                            </LeadText>
                            <LeadText style={{ marginTop: '0' }}>
                                Nous nous excusons pour tout inconvénient. Merci de votre
                                compréhension.
                            </LeadText>
                            <TextParagraph>
                                S&apos;il vous plaît visitez-nous à nouveau.
                            </TextParagraph>
                        </MarginBlock>
                    </TextContainer>
                </OntarioColumn>
            </OntarioRow>
        </Wrapper>
    );
};

export default Maintenance;
